import axios from '@/config/api.eating.req.js'
import config from '@/config/config.js'

/**
 * 获取食物大类
 */
export const getFoodSpecies = () => {
        return new Promise((resolve, reject) => {
            axios.request({
                url: "/food/species",
                method: 'get',
                params: {},
                headers: {},
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
    /**
     * 获取banner
     */
export const getBanner = () => {
    return new Promise((resolve, reject) => {
        axios.request({
            url: "/food/banner/",
            method: 'get',
            params: {},
            headers: {},
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取食物列表
 * @param {String} foodTypeId 食物类型id
 * @param {Sting} foodName 食物名称
 * @param {Number} pageNumber 页码
 * @param {Number} pageSize 页数
 */
export const getFoodList = (foodTypeId, foodName, pageNumber, pageSize) => {
        return new Promise((resolve, reject) => {
            axios.request({
                url: '/food/species/' + pageNumber + '/' + pageSize,
                method: 'get',
                params: {
                    foodTypeId,
                    foodName
                },
                headers: {
                    'Content-type': 'application/json;charset=UTF-8',
                },
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
    /** 
     * 获取食物详情 /food/detail/{foodId}
     * @param {String} foodId 页数
     */
export const getDetails = (foodId) => {
    return new Promise((resolve, reject) => {
        axios.request({
            url: '/food/detail/' + foodId,
            method: 'get',
            params: {},
            headers: {},
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 反馈
 * @param {String} feedBackInfo 反馈内容
 */
export const feedBack = (feedBackContent) => {
    return new Promise((resolve, reject) => {
        axios.request({
            url: '/food/feedBack',
            method: 'POST',
            data: { feedBackContent },
            headers: {},
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * 获取wx分享 配置
 * @param {String} url 要用的微信接口
 */
export const getWxConfig = (url) => {
    return new Promise((resolve, reject) => {
        axios.request({
            url: '/official/signature',
            method: 'POST',
            data: { "url": url },
            headers: {},
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 获取页面banner
 * @param {String} queryVo 需要用到的数据
 */
export const getAnnounceBanner = (queryVo) => {
    let url = config.eatingConfig.baseUrl.getBanner + '/resources/banner'
    return new Promise((resolve, reject) => {
        axios.request({
            url: url,
            method: 'GET',
            params: queryVo,
            headers: {},
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}